import { passwordRegex } from "@/app/account/constants/regex"
import { isNil } from "lodash"

export default function useGetNewPwdIsValid(newPassword?: string, confirmNewPassword?: string) {
  if (
    isNil(newPassword) ||
    isNil(confirmNewPassword) ||
    newPassword === "" ||
    confirmNewPassword === "" ||
    newPassword !== confirmNewPassword
  ) {
    return false
  }

  if (!passwordRegex.test(newPassword) || !passwordRegex.test(confirmNewPassword)) {
    return false
  }

  return true
}
